import IAuthStore from './auth-store.interface';
import Vue from 'vue';

const mutations = {
    SET_ACCESS_TOKEN(state: IAuthStore, payload: string): void {
        state.accessToken = payload;
    },
    SET_USERINFORMATION(state: IAuthStore, payload: any): void {
        Object.keys(payload).forEach((key: string) => {
            Vue.set(state.userInformation, key, payload[key]);
        });
    }
};

export default mutations;
